export default "__VITE_ASSET__CQaX_BRc__"